// extracted by mini-css-extract-plugin
export default {"root":"uTOb9","image":"_268g_","large":"_2GuA3","medium":"ap0G8","small":"_3I4WU"};